export default __webpack_public_path__ + "static/blackRing-9b9c725c682fbc04a7122f35fd424f16.png";